/**
 * @file Renders a `coerceCellValue` result value for the Mapping Review preview
 * surfaces so the reviewer sees exactly what the writer will persist. Dates
 * render as unambiguous ISO (locale-independent — the point of verifying date
 * order); a resolved range renders as its ISO endpoints; `null` (won't-import)
 * renders empty. Shared by `MappingReviewFields` (header) and `MappingReviewRows`
 * (table cells) so both previews stay byte-identical to each other and the writer.
 */
export function formatCoercedValue(
  value: string | number | boolean | Date | { start: Date; end: Date } | null,
): string {
  if (value === null) return '';
  if (value instanceof Date) return value.toISOString();
  if (typeof value === 'object') return `${value.start.toISOString()} – ${value.end.toISOString()}`;
  return String(value);
}
